<template>
  <role-info-form
    v-if="isChildComponentLoaded"
    :formEdit="formEdit"
    :isEditPage="true"
    @on-submit="editRole"
  ></role-info-form>
</template>

<script>
import RoleInfoForm from "./RoleInfoForm.vue";
import { role_router_names } from "@/routes/routes";
import { service_paths } from "@/constants/Services";
import { Message } from "@/helpers/utils";
import pick from "lodash/pick";
import { mapActions } from "vuex";
export default {
  components: { RoleInfoForm },
  data() {
    return {
      formEdit: {
        name: "",
        status: "",
        description: "",
        count_user: null,
        permission_ids: []
      },
      isChildComponentLoaded: false
    };
  },
  created() {
    this.fetchrole();
  },
  methods: {
    ...mapActions("user", ["FetchUserInformation"]),
    fetchrole() {
      const role_id = this.$route.params.id;
      return this.$axios
        .get(`${service_paths.roles}/${role_id}`)
        .then(response => {
          this.formEdit = pick(response.data, Object.keys(this.formEdit));
          this.formEdit.permission_ids = this.getPermissionIds(response.data);
          this.isChildComponentLoaded = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getPermissionIds(resData) {
      const perissionIds = [];
      resData.permissions?.forEach(item => {
        return perissionIds.push(item.id);
      });
      return perissionIds;
    },
    editRole(formData) {
      const role_id = this.$route.params.id;
      this.$axios
        .put(`${service_paths.roles}/${role_id}`, formData)
        .then(() => {
          Message.success(this.$t("common.edit_success"));
          this.FetchUserInformation();
          this.$router.push({ name: role_router_names.listPage });
        });
    }
  }
};
</script>

<style></style>
